const input = {
    username: "Ім'я користувача",
    password: 'Пароль',
    email: 'Електронна пошта',
    phone_number: 'Номер телефону',
    student_number: 'Студентський номер',
    registration_number: 'Реєстраційний номер',
    student_identifier_legend: 'Увійти за допомогою',
    confirm_password: 'Підтвердити пароль',
    search_region_code: 'Пошук коду регіону',
    backup_code: 'Резервний код',
    code: 'Код',
    label_with_optional: "{{label}} (Необов'язково)",
};
export default Object.freeze(input);
